<template>
  <section class="richText container--Small">
    <div v-html="data" />
  </section>
</template>

<script setup>
  const props = defineProps({ data: {}});
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_richText.scss');
</style>